module.exports = __webpack_public_path__ + "img/marketing-2.0ce85b6b.png";